import styled, { css } from 'styled-components';

type ButtonVariant = 'contained' | 'outlined';
type ButtonColor = 'primary' | 'secondary';

interface ButtonProps {
    variant?: ButtonVariant;
    color?: ButtonColor;
    disabled?: boolean;
    fullWidth?: boolean;
}

const colors = {
    primary: {
        main: '#1976d2',
        contrast: '#fff',
        hover: '#1565c0',
    },
    secondary: {
        main: '#9c27b0',
        contrast: '#fff',
        hover: '#7b1fa2',
    },
};

export const FtButton = styled.button<ButtonProps>`
    .button-group > &:not(:first-child) {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
    }
    
    .button-group > &:not(:last-child) {
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
        margin-right: -1px;
    }
    
    font-size: 0.875rem;
    font-weight: 500;
    height: 32px;
    padding: 0 8px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    outline: none;
    border: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: ${({fullWidth}) => (fullWidth ? '100%' : 'auto')};

    ${({color = 'primary', variant = 'contained', disabled}) => {
        const c = colors[color];
        if (variant === 'contained') {
            return css`
                background-color: ${c.main};
                color: ${c.contrast};

                &:hover {
                    background-color: ${!disabled && c.hover};
                }

                ${disabled &&
                css`
                    background-color: #e0e0e0;
                    color: #9e9e9e;
                    cursor: not-allowed;
                `}
            `;
        }

        if (variant === 'outlined') {
            return css`
                background: transparent;
                color: ${c.main};
                border: 1px solid ${c.main};

                &:hover {
                    background-color: rgba(25, 118, 210, 0.04);
                }

                ${disabled &&
                css`
                    border-color: #e0e0e0;
                    color: #9e9e9e;
                    cursor: not-allowed;
                `}
            `;
        }
    }}
`;
